import type { AxiosRequestConfig } from 'axios'
import { http } from './index'

export interface ResetUserPasswordPayload {
    password: string
    send_to_email: boolean
    email?: string
}

export async function getEmployments() {
    return await http.get<any>(`/api/employments/`)
}

export async function createUser(data:any) {
    return await http.post<any>(`/api/user/`, data)
}

export async function getUser(id:string) {
    return await http.get<any>(`/api/user/${id}/`)
}

export async function getUsersFired(params:any) {
    return await http.get<any>('/api/user/fired/', { params })
}

export async function getUsers(params:any) {
    return await http.get<any>('/api/user/', { params })
}

// config — необязательный (RD-149: досье подавляет глобальный toast и показывает ошибку на форме).
export async function editUser(data: any, id: string, config?: AxiosRequestConfig) {
    return await http.patch<any>(`/api/user/${id}/`, data, config)
}

export async function resetUserPassword(id: string, data: ResetUserPasswordPayload) {
    return await http.post<any>(`/api/user/${id}/reset-password/`, data, {
        suppressGlobalErrorToast: true
    })
}

export async function getEmployment(id:string) {
    return await http.get<any>(`/api/employments/${id}/`)
}

export async function postEmployment(data:any, config?: AxiosRequestConfig) {
    return await http.post<any>(`/api/employments/`, data, config)
}

export async function getEmploymentSchedule(id:string, params: any) {
    return await http.get<any>(`/api/employments/${id}/schedule/`, {params})
}

export async function editEmployment(id:string, data: any, config?: AxiosRequestConfig) {
    return await http.patch<any>(`/api/employments/${id}/`, data, config)
}

// RD-161: данные досье по User (path id — User UUID, не Employment). main private API, read-only.
// Досье показывает ошибку в своём блоке, поэтому глобальный toast подавлен.
// month_from/month_to — YYYY-MM; server: can_view_user_list.
export interface UserDisciplineParams {
    month_from: string
    month_to: string
    page: number
    page_size: number
}

export async function getUserDiscipline(id: string, params: UserDisciplineParams) {
    return await http.get<any>(`/api/user/${id}/discipline/`, { params, suppressGlobalErrorToast: true })
}

// date_from (нет — всё время) / date_to — YYYY-MM-DD; server: can_view_vacancy_responses.
export interface UserExchangeParams {
    date_from?: string
    date_to: string
}

export async function getUserExchangeSummary(id: string, params: UserExchangeParams) {
    return await http.get<any>(`/api/user/${id}/exchange-summary/`, { params, suppressGlobalErrorToast: true })
}

export async function getUserVacancyResponses(id: string, params: UserExchangeParams & { page: number, page_size: number }) {
    return await http.get<any>(`/api/user/${id}/vacancy-responses/`, { params, suppressGlobalErrorToast: true })
}

// Без query и пагинации; только незавершённые/будущие документы. server: can_view_user_list.
export async function getUserDayStateDocuments(id: string) {
    return await http.get<any>(`/api/user/${id}/day-state-documents/`, { suppressGlobalErrorToast: true })
}
